var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionManufacturerList", {
        attrs: {
          xs12: "",
          manufacturerList: _vm.manufacturerList,
          shouldShowSearch: true,
          toolbarActions: [
            {
              text: "Manufacturer",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewManufacturerClicked",
            },
          ],
          isLoading: _vm.isLoading,
        },
        on: {
          onAddNewManufacturerClicked: function ($event) {
            _vm.showDialogFormManufacturerAdd = true
          },
          onEditManufacturerClicked: (val) => [
            (_vm.manufacturerToEdit = val.manufacturerToEdit),
            (_vm.showDialogFormManufacturerEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormManufacturerAdd", {
        attrs: {
          showDialog: _vm.showDialogFormManufacturerAdd,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormManufacturerAdd = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormManufacturerAddSubmit(val),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormManufacturerEdit", {
        attrs: {
          showDialog: _vm.showDialogFormManufacturerEdit,
          manufacturerToEdit: _vm.manufacturerToEdit,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormManufacturerEdit = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormManufacturerEditSubmit(val),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }